import * as React from 'react';
import { SelectSingleHierarchy } from 'app/area/shared/translated-components';
import { LoadOptions } from 'app/types-shared';
import { CodeSinglePickerState, CodeSinglePickerProps } from '../types';

export class CodeSinglePicker extends React.PureComponent<CodeSinglePickerProps, CodeSinglePickerState> {

  public readonly state: Readonly<CodeSinglePickerState> = { loadedOptions: {} };

  private onLoadOptions = (options: LoadOptions) => {

    const { id, onLoadOptions } = this.props;

    onLoadOptions(id, options);
    this.setState({ loadedOptions: options });
  };

  private clearLoadOptions = () => {
    this.setState({ loadedOptions: {} });
  };

  public render() {

    const {
      id, label, valueItem, options, fetchingOptions, translation, showBackgroundColour, includeDisabledLabel,
      enableMultilineValidation, required, searchRequired, validation, readOnly, leafNodeOnly, minLength,
      displayCategories, categoryOptions, onChange, onLoadCategoryOptions, extraFooterButton
    } = this.props;

    return <SelectSingleHierarchy
      componentId={id}
      className={undefined}
      label={label ? { text: label, required: !!required } : undefined}
      readOnly={readOnly}
      extraFooterButton={extraFooterButton}
      valueItem={valueItem}
      searchRequired={searchRequired}
      onChange={onChange}
      showBackgroundColour={showBackgroundColour}
      descriptionAllLevels={true}
      enableMultilineValidation={enableMultilineValidation}
      options={options}
      fetching={fetchingOptions}
      loadOptions={this.state.loadedOptions}
      onLoadOptions={this.onLoadOptions}
      displayCategories={displayCategories}
      categoryOptions={categoryOptions}
      onLoadCategoryOptions={onLoadCategoryOptions}
      leafNodeOnly={leafNodeOnly}
      minLength={minLength}
      placeholder={translation.search}
      includeDisabledLabel={includeDisabledLabel}
      clearLoadOptions={this.clearLoadOptions}
      validation={validation} />;
  }
}
